module.exports = __webpack_public_path__ + "static/media/13_topbandas_mobile.f7ef1e71.jpg";